import {GridBox} from '@esgi/ui/layout';
import {styled} from '@esgi/ui/theme';

export const contentRowGap = 40;

export const Content = styled(GridBox, {
	rowGap: contentRowGap,
});
